import { LabelEnum } from 'app/shared/enums';

const haveToBeTrue = (value: boolean | undefined) =>
  value === true ? undefined : LabelEnum.ConsentRequired;

export default haveToBeTrue;
